<app-modal
  title="{{ data?.type === 'in' ? ('Cash in' | trans:'safes/cash-in-out-modal/in/header/title') : ('Cash out' | trans:'safes/cash-in-out-modal/out/header/title') }}"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      <app-content-editable-input (valueChange)="amountValue = $event" />
    </div>

    <div class="m-t-24">
      <app-content-box theme="gray">
        <app-keyboard
          [isSimple]="false"
          (clear)="handleKeyboardClear()"
          (deleteBack)="handleKeyboardDeleteBack()"
          (keyClick)="handleKeyboardKeyClick($event)"
        />
      </app-content-box>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'safes/cash-in-out-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        [appWebCashPermissionControl]="permissionKeys.WebCxCashSafes"
        [extraDisabled]="isConfirmDisabled"
        (click)="descriptionModalComponent.open()"
      >
        {{ 'Confirm'| trans:'safes/cash-in-out-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-description-modal
  (onOpen)="remark = null"
  #descriptionModalComponent
  (confirm)="remark = $event.description; datevAccountPickerModal.open()"
/>

<app-modal
  [title]="'DATEV - Konto' | trans:'safes/cash-in-out-modal/datev-account-picker-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
  #datevAccountPickerModal
>
  <ng-template>
    <app-select
      class="full-width"
      [options]="datevOptions"
      [placeholder]="'DATEV - Konto' | trans:'terminal-session-modal/form/safe-number.Placeholder'"
      [hasResetOption]="false"
      outputType="number"
      [canUnselect]="false"
      [(ngModel)]="datevId"
    />
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="datevAccountPickerModal.close(); datevId = datevOptions[0].id;"
      >
        {{ 'Cancel' | trans:'safes/cash-in-out-modal/datev-account-picker-modal/cancel.Button' }}
      </button>

      <button
        #btn
        class="button button--md button--primary text-uppercase"
        [appWebCashPermissionControl]="permissionKeys.WebCxCashSafes"
        (click)="confirmProcess(btn)"
      >
        {{ 'Confirm'| trans:'safes/cash-in-out-modal/datev-account-picker-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
